import { forwardRef } from 'react'
import { Input, type InputProps } from '@shared/ui/Input/Input'

const EMAIL_TYPE = 'email'
const DEFAULT_PLACEHOLDER = 'name@example.com'

export const EmailInput = forwardRef<HTMLInputElement, Omit<InputProps, 'type'>>((props, ref) => {
  return (
    <Input
      ref={ref}
      {...props}
      type={EMAIL_TYPE}
      placeholder={props.placeholder ?? DEFAULT_PLACEHOLDER}
    />
  )
})
EmailInput.displayName = 'EmailInput'
